import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import Table from 'react-bootstrap/lib/Table'
import { actions } from 'react-redux-form/immutable'
import acc from 'accounting'

import ConfirmDialog from 'components/ConfirmDialog'
import { removeSubject } from 'containers/Enrolment/actions'

import ListEnrolledItem from './list-enrolled-item'

class ListSelected extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showConfirm: false,
      itemID: null,
    }
  }

  _showConfirm = (itemID) => {
    this.setState({
      showConfirm: true,
      itemID,
    })
  }

  _hideConfirm = () => {
    this.setState({
      showConfirm: false,
      itemID: null,
    })
  }

  _onRemove = () => {
    const { itemID } = this.state
    const { dispatch, __semcampID } = this.props
    dispatch(removeSubject(itemID, __semcampID))
      .then((res) => {
        if (!res.error) {
          dispatch(actions.change('enrolledState', fromJS(res.payload)))
          this._hideConfirm()
        }
      })
  }

  _renderConfirm() {
    const { showConfirm } = this.state
    const { __pending } = this.props
    if (!showConfirm) {
      return null
    }

    return (
      <ConfirmDialog
        msg="Are you sure to remove this subject?"
        closeDialog={this._hideConfirm}
        confirmAction={this._onRemove}
        btnClass="btn-danger"
        pending={__pending}
      />
    )
  }

  render() {
    const { __enrolled } = this.props
    let total = 0

    return (
      <div>
        <Table condensed className="table--cor">
          <thead>
            <tr>
              <th width="3%"></th>
              <th width="10%">Code</th>
              <th width="8%">Section</th>
              <th>Subject Description</th>
              <th width="20%">Schedule</th>
              <th width="5%" className="text-right">Lec</th>
              <th width="5%" className="text-right">Lab</th>
              <th width="5%" className="text-right">Units</th>
              <th width="15%">Instructor</th>
            </tr>
          </thead>
          <tbody>
            {__enrolled.map((item, k) => {
              total += item.get('units') - 0
              return (
                <ListEnrolledItem
                  key={k}
                  item={item}
                  onRemove={this._showConfirm}
                />
              )
            })}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan="7" className="text-right">Total Units:</th>
              <th className="text-right">{acc.formatNumber(total, 1)}</th>
              <th></th>
            </tr>
          </tfoot>
        </Table>
        {this._renderConfirm()}
      </div>
    )
  }
}

ListSelected.propTypes = {
  __semcampID: PropTypes.number,
  __enrolled: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    __enrolled: state.enrolledState,
    __semcampID: state.auth.getIn(['me', 'semcamp_id']),
  }
}

export default connect(mapStateToProps)(ListSelected)



// WEBPACK FOOTER //
// ./src/containers/Enrolment/Modify/list-enrolled.js